import { useEffect } from "react";
import { send_request } from "../../../utils/Request";
import useAgentStore from "../useAgentStore";

export default function useWorkerStatuses(parentSessionId) {
  const workerStatusMap = useAgentStore((s) => s._workerStatuses);

  useEffect(() => {
    if (!parentSessionId) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await send_request(
          `ai-service/private/ai/agent/session/${parentSessionId}/workers`,
          "",
          {},
          "GET"
        );
        if (cancelled || !Array.isArray(res?.data)) return;
        const map = {};
        for (const w of res.data) {
          if (w.chatSessionId) map[w.chatSessionId] = w;
        }
        if (Object.keys(map).length > 0) {
          useAgentStore.setState((s) => ({
            _workerStatuses: { ...map, ...s._workerStatuses },
          }));
        }
      } catch {
        // silently ignore
      }
    })();
    return () => { cancelled = true; };
  }, [parentSessionId]);

  return { bySessionId: workerStatusMap || {} };
}
